import React from "react";
import {
    captureSlowInitialNavigation,
    captureSlowRouteTransition
} from "./performanceLogger";

type Props = {
    pathname: string;
};

const AppDiagnostics = ({ pathname }: Props) => {
    const previousPathRef = React.useRef<string | null>(null);

    React.useEffect(() => {
        if (!pathname) {
            return;
        }

        if (previousPathRef.current === null) {
            previousPathRef.current = pathname;
            void captureSlowInitialNavigation(pathname);
            return;
        }

        if (previousPathRef.current === pathname) {
            return;
        }

        const previousPathname = previousPathRef.current;
        previousPathRef.current = pathname;

        const startedAt = performance.now();
        let isCancelled = false;
        let firstFrameId = 0;
        let secondFrameId = 0;

        firstFrameId = window.requestAnimationFrame(() => {
            secondFrameId = window.requestAnimationFrame(() => {
                if (isCancelled) {
                    return;
                }

                void captureSlowRouteTransition({
                    routePath: pathname,
                    previousRoutePath: previousPathname,
                    durationMs: performance.now() - startedAt
                });
            });
        });

        return () => {
            isCancelled = true;
            window.cancelAnimationFrame(firstFrameId);
            window.cancelAnimationFrame(secondFrameId);
        };
    }, [pathname]);

    return null;
};

export default AppDiagnostics;
